import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/faq/:nodeIdentifier', 
            component: () => import('./views/faq.vue'),
            meta: {
                hasBar: true
            }
        },
    ];
};